module.exports = __webpack_public_path__ + "img/shaixuanxuanzhong.b204d77b.svg";